const PLAYER_AUTOPLAY_INTENT_KEY = "rhebus-player-autoplay-intent-ts";
const PLAYER_AUTOPLAY_INTENT_TTL_MS = 30_000;

export function markUserInitiatedPlayerEntry() {
  try {
    window.sessionStorage.setItem(
      PLAYER_AUTOPLAY_INTENT_KEY,
      String(Date.now())
    );
  } catch (error) {
    console.warn("[AUTOPLAY_INTENT] Unable to persist user intent", error);
  }
}

export function consumeUserInitiatedPlayerEntry() {
  try {
    const rawTimestamp = window.sessionStorage.getItem(
      PLAYER_AUTOPLAY_INTENT_KEY
    );
    if (!rawTimestamp) return false;

    window.sessionStorage.removeItem(PLAYER_AUTOPLAY_INTENT_KEY);

    const timestamp = Number(rawTimestamp);
    if (!Number.isFinite(timestamp)) return false;

    return Date.now() - timestamp <= PLAYER_AUTOPLAY_INTENT_TTL_MS;
  } catch (error) {
    console.warn("[AUTOPLAY_INTENT] Unable to read user intent", error);
    return false;
  }
}
